import { Header, Text } from '@rbilabs/universal-components';

import { ActionButtonVariants } from 'components/action-button';
import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import { t } from 'state/intl/translations';

import { ButtonsContainer, DrawerContainer, StyledActionButton } from './styles';

interface NonTraditionalStoreDialogDrawerProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  accessInstructions: string;
}

export const NonTraditionalStoreDialogDrawer = ({
  isOpen,
  onConfirm,
  onCancel,
  accessInstructions,
}: NonTraditionalStoreDialogDrawerProps) => {
  return (
    <ActionsheetWrapper
      onClose={onCancel}
      isOpen={isOpen}
      onOpenEventMessage="Open Non Traditional Store Drawer"
    >
      <ActionsheetContent>
        <DrawerContainer>
          <Header textAlign="center">{t('nonTraditionalStoreDrawerHeader')}</Header>
          <Text marginBottom="$4" textAlign="center">
            {accessInstructions}
          </Text>
          <ButtonsContainer>
            <StyledActionButton onPress={onConfirm}>{t('selectAnyways')}</StyledActionButton>
            <StyledActionButton onPress={onCancel} variant={ActionButtonVariants.OUTLINE}>
              {t('chooseAnotherLocation')}
            </StyledActionButton>
          </ButtonsContainer>
        </DrawerContainer>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
